export interface Expectation {
  text: string;
  showFindVinButton?: boolean;
}

export interface ExpectationContent {
  headerText: string;
  sendToAgentText: string;
  sendToAdvisorText?: string;
}

export interface VinContent {
  linkText: string;
  headerText: string;
  definition: string;
  documentsSubHeader: string;
  vinOnDocument: string;
  yourVehicleSubHeaderText: string;
  vinOnVehicle: string;
}

export enum Code {
  SEND_TO_AGENT_ANS = 'ANSMYECRAV'
}

export enum Content {
  SEND_TO_AGENT_ANS = 'policy.expectationSettingANSContent'
}
